<template>
    <div class="container full-width">
        <div class="row items-center justify-between">
            <div class="text-subtitle1">No plastic bags</div>
            <q-toggle :value="noPlasticBags" @input="onUpdateNoPlasticBags" />
        </div>
        <!-- <div class="row items-center justify-between">
            <div class="text-subtitle1">Request tax invoice</div>
            <q-toggle/>
        </div> -->
        <div class="row items-center justify-between">
            <div class="text-subtitle1">Request subtitutes</div>
            <q-toggle  :value="requestSubstitute" @input="onUpdateRequestSubstitute"  />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "Options",
    computed: {
        ...mapState({
            noPlasticBags: (state) => state["checkout"]["noPlasticBags"],
            requestSubstitute: (state) =>
                state["checkout"]["requestSubstitute"],
        }),
    },
    methods: {
        async onUpdateNoPlasticBags() {
            this.$store.commit(
                "checkout/setNoPlasticBags",
                !this.noPlasticBags
            );
            await this.$store.dispatch("checkout/updateDraftOrder");
        },
        async onUpdateRequestSubstitute() {
            this.$store.commit(
                "checkout/setRequestSubstitute",
                !this.requestSubstitute
            );
            await this.$store.dispatch("checkout/updateDraftOrder");
        },
    },
};
</script>

<style scoped>

.container {
    padding: 0px 8px;
}

</style>
